import { User } from './user';

export class Logistic extends User {

}
